export const searchGridSx = {
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    sm: "repeat(2, minmax(0, 1fr))",
    md: "repeat(4, minmax(0, 1fr))",
  },
  gap: 2,
  alignItems: "center",
  "& > .MuiGrid-root": {
    width: "100%",
    maxWidth: "none",
    flexBasis: "auto",
    paddingLeft: "0 !important",
    paddingTop: "0 !important",
  },
  "& .MuiFormControl-root, & .MuiTextField-root, & .MuiButton-root": {
    width: "100%",
  },
};
